import {
  Activity,
  CircleDollarSign,
  ImagePlus,
  QrCode,
  ShoppingBag,
  UtensilsCrossed,
} from 'lucide-react';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../contexts/LanguageContext';

const getActivityIcon = (
  activity,
) => {
  const module =
    String(
      activity?.module ||
        '',
    ).toLowerCase();

  if (
    module.includes(
      'order',
    )
  ) {
    return ShoppingBag;
  }

  if (
    module.includes(
      'product',
    )
  ) {
    return UtensilsCrossed;
  }

  if (
    module.includes(
      'qr',
    )
  ) {
    return QrCode;
  }

  if (
    module.includes(
      'image',
    )
  ) {
    return ImagePlus;
  }

  if (
    module.includes(
      'price',
    )
  ) {
    return CircleDollarSign;
  }

  return Activity;
};

const formatRelativeTime = (
  value,
  language,
) => {
  if (!value) {
    return '';
  }

  const date =
    new Date(value);

  const diffMs =
    Date.now() -
    date.getTime();

  const minutes =
    Math.max(
      0,
      Math.round(
        diffMs / 60000,
      ),
    );

  const formatter =
    new Intl.RelativeTimeFormat(
      language,
      {
        numeric: 'auto',
      },
    );

  if (minutes < 60) {
    return formatter.format(
      -minutes,
      'minute',
    );
  }

  const hours =
    Math.round(
      minutes / 60,
    );

  if (hours < 24) {
    return formatter.format(
      -hours,
      'hour',
    );
  }

  const days =
    Math.round(
      hours / 24,
    );

  return formatter.format(
    -days,
    'day',
  );
};

function RecentActivity({
  activities = [],
  canViewAll = true,
}) {
  const {
    t,
    language,
  } = useLanguage();

  return (
    <section className="dashboard-panel">
      <div className="dashboard-panel__header">
        <div>
          <h2>
            {t(
              'dashboard.recentActivity',
            )}
          </h2>

          <p>
            {t(
              'dashboard.recentActivityDescription',
            )}
          </p>
        </div>

        {canViewAll ? (
          <Link
            to="/activity-tracking"
            className="dashboard-text-link"
          >
            {t(
              'common.viewAll',
            )}
          </Link>
        ) : null}
      </div>

      {activities.length ? (
        <div className="recent-activity">
          {activities.map(
            (activity) => {
              const ActivityIcon =
                getActivityIcon(
                  activity,
                );

              return (
                <article
                  className="recent-activity__item"
                  key={
                    activity.id
                  }
                >
                  <span className="recent-activity__icon">
                    <ActivityIcon
                      size={18}
                    />
                  </span>

                  <div className="recent-activity__content">
                    <strong>
                      {activity.user_name ||
                        t(
                          'dashboard.dynamic.activity.system',
                        )}
                    </strong>

                    <p>
                      {activity.description ||
                        t(
                          'dashboard.dynamic.activity.fallback',
                          {
                            module:
                              activity.module ||
                              '',
                            action:
                              activity.action ||
                              '',
                          },
                        )}
                    </p>
                  </div>

                  <time>
                    {formatRelativeTime(
                      activity.created_at,
                      language,
                    )}
                  </time>
                </article>
              );
            },
          )}
        </div>
      ) : (
        <div className="dashboard-mini-empty dashboard-mini-empty--activity">
          {t(
            'dashboard.dynamic.activity.empty',
          )}
        </div>
      )}
    </section>
  );
}

export default RecentActivity;
